export const iconFontAwesomeGendersNeuter = (
	<i className="fa-solid fa-neuter"></i>
);
